import { Component, DestroyRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { API, AttachmentDTO, AttachmentType, DisplayType } from '../../../../../services/api/api';
import { ToasterService, ToastType } from '../../../../../services/toaster/toaster.service';
import * as _ from 'lodash';
import { UtilService } from '../../../../../services/util.service';
import { TranslateService } from '@ngx-translate/core';
import { AttachmentService } from '../../../../../services/attachment.service';
import { AttachmentEditEmitter } from '../../../../../services/global/global-interfaces';
import { take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { enumKeys } from '../../../../../services/global/global-methods';

@Component({
  selector: 'app-attachment-file',
  templateUrl: './attachment-file.component.html',
  styleUrls: ['./attachment-file.component.scss'],
  standalone: false,
})
export class AttachmentFileComponent implements OnInit {
  displaySelection: DisplayType[];
  @Input() attachment: AttachmentDTO;
  @Output() attachmentEmitter: EventEmitter<AttachmentEditEmitter> = new EventEmitter<AttachmentEditEmitter>();
  form = new UntypedFormGroup({
    Title: new UntypedFormControl('', [Validators.required]),
    Description: new UntypedFormControl('', []),
    DisplayTypeForm: new UntypedFormControl('', [Validators.required]),
  });

  constructor(
    private api: API,
    private toaster: ToasterService,
    public util: UtilService,
    private translate: TranslateService,
    private attachmentService: AttachmentService,
    private destroyRef: DestroyRef
  ) {
    this.displaySelection = [];
  }

  get Title() {
    return this.form.get('Title');
  }

  get Description() {
    return this.form.get('Description');
  }

  get DisplayTypeForm() {
    return this.form.get('DisplayTypeForm');
  }

  ngOnInit(): void {
    this.initEnum();
    if (this.attachment) {
      this.updateForm();
    }
    this.form = _.cloneDeep(this.form); // Prevent databinding
  }

  initEnum() {
    const displayKeys = enumKeys(DisplayType);
    this.displaySelection = [];
    for (const val of displayKeys) {
      this.displaySelection.push(DisplayType[val]);
    }
    if (this.attachment?.displayType) {
      this.DisplayTypeForm.setValue(this.attachment.displayType);
    } else {
      this.DisplayTypeForm.setValue(this.displaySelection.find(x => x === DisplayType.EMBED));
    }
  }

  saveFileAttachment() {
    if (this.form.valid) {
      this.getChanges();
      if (this.attachment?.id) {
        this.api
          .shared_Attachment_editAttachment(this.attachment)
          .pipe(takeUntilDestroyed(this.destroyRef), take(1))
          .subscribe(data => {
            this.attachmentService.attachmentChange.next({
              type: 'edit',
              attachment: data,
            });
            this.toaster.toast(ToastType.SUCCESS, this.translate.instant('lang.globals.successful') + '!');
          });
      }
    }
  }

  updateForm() {
    if (this.attachment?.id && this.attachment?.attachmentType === AttachmentType.UPLOAD) {
      this.Title.setValue(this.attachment.name);
      this.Description.setValue(this.attachment.description);
      this.DisplayTypeForm.setValue(this.attachment.displayType);
    }
  }

  private getChanges() {
    this.attachment.name = this.Title.value;
    this.attachment.description = this.Description.value;
    this.attachment.displayType = this.DisplayTypeForm.value;
  }
}
